import React, { useContext, useRef, useState } from 'react';

import { media } from 'context';
import { Layout } from 'ds';

const AiOfficeAssistantVideo: React.FC = () => {
  const { isMobile } = useContext(media);
  const [showControls, setShowControls] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [shouldPlay, setShouldPlay] = useState(false);

  const handleVideoClick = () => {
    if (showControls) return;
    setShowControls(true);
    setShouldPlay(true);
    if (isMobile && videoRef.current) {
      videoRef.current.play();
    }
  };

  const handleCanPlay = () => {
    if (shouldPlay && videoRef.current) {
      videoRef.current.play();
    }
  };

  return (
    <Layout paddingY={isMobile ? 64 : 100} width="100%" paddingX={isMobile ? 24 : 0}>
      <Layout
        maxWidth={1120}
        maxHeight={642}
        __style={{
          borderRadius: '16px'
        }}
      >
        <video
          controls={showControls}
          onClick={handleVideoClick}
          onCanPlay={handleCanPlay}
          poster={
            isMobile
              ? 'https://assets.codi.com/public/videoThumbnailMobile_J4Tx7CIzY.png?updatedAt=1747940730541'
              : 'https://assets.codi.com/public/videoThumbnailDesktop_j_ICWrh2y.png?updatedAt=1747940844891'
          }
          ref={videoRef}
          playsInline
          disablePictureInPicture
          onLoadedMetadata={() => {
            if (videoRef.current) {
              videoRef.current.volume = 0.75;
            }
          }}
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '16px'
          }}
        >
          <source
            src="https://assets.codi.com/public/LaunchVideo_Homepage_AtN09A6D_.mp4?updatedAt=1747843803299"
            type="video/webm"
          />
          <source
            src="https://assets.codi.com/public/LaunchVideo_Homepage_o6VOntZpj.webm/ik-video.mp4?updatedAt=1747843736931"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </Layout>
    </Layout>
  );
};

export default AiOfficeAssistantVideo;
